import { render, staticRenderFns } from "./PeriodRadioGroup.vue?vue&type=template&id=105b536e&"
import script from "./PeriodRadioGroup.vue?vue&type=script&lang=js&"
export * from "./PeriodRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports